import homeGallery1 from "@/assets/home-gallery-1.png";
import homeGallery2 from "@/assets/home-gallery-2.png";
import homeGallery3 from "@/assets/home-gallery-3.png";

const HomeGallery = () => {
  const items = [
    {
      title: "Comunidades na Caatinga",
      description:
        "Visitas, discipulado e cuidado contínuo em vilarejos do sertão nordestino.",
      image: homeGallery1,
      alt: "Momento de culto e reunião com comunidade na Caatinga",
    },
    {
      title: "Momentos de oração",
      description:
        "Intercessão e ministração em casas, praças e igrejas locais.",
      image: homeGallery2,
      alt: "Momento de leitura bíblica e pregação no púlpito de missões",
    },
    {
      title: "Ação social prática",
      description:
        "Distribuição de cestas, apoio a crianças e acompanhamento de famílias vulneráveis.",
      image: homeGallery3,
      alt: "Encontro ao ar livre com a comunidade, pessoas ouvindo mensagem cristã",
    },
  ];

  return (
    <section className="section-shell bg-accent/40">
      <div className="mb-10 text-center">
        <p className="section-title">Galeria</p>
        <h2 className="section-heading">Um retrato da missão em movimento.</h2>
        <p className="section-subtitle mx-auto">
          Imagens ilustrativas que contam histórias de fé, serviço e esperança no sertão e na vida da igreja.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-3">
        {items.map((item) => (
          <figure key={item.title} className="card-ambient hover-lift flex flex-col overflow-hidden">
            {item.image ? (
              <img
                src={item.image}
                alt={item.alt}
                className="h-40 w-full object-cover"
                loading="lazy"
                width={400}
                height={160}
              />
            ) : (
              <div className="h-40 bg-gradient-to-br from-primary/40 via-secondary/40 to-background" />
            )}
            <figcaption className="space-y-2 p-5">
              <p className="text-sm font-semibold text-foreground">{item.title}</p>
              <p className="text-sm text-muted-foreground">{item.description}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
};

export default HomeGallery;
